import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, Functions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDGpsEy1raWHqLaFHTt1B5H9u1EZSGzUuE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "wheresmyfriend-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "wheresmyfriend-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "wheresmyfriend-dev.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "256812518840",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:256812518840:web:3d3de3ba8d22210a9fd34d",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-541Q6VNSXL",
};

// Initialize Firebase
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app);

// Connect to emulators in development
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

if (useEmulators && typeof window !== 'undefined') {
  // Only connect if not already connected (check for emulator connection)
  const authConnected = (auth as any)._delegate?._config?.emulator;
  const dbConnected = (db as any)._delegate?._settings?.host?.includes('localhost');
  const storageConnected = (storage as any)._delegate?._host?.includes('localhost');

  if (!authConnected) {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    } catch (e) {
      console.warn('Auth emulator already connected or connection failed:', e);
    }
  }

  if (!dbConnected) {
    try {
      connectFirestoreEmulator(db, 'localhost', 8080);
    } catch (e) {
      console.warn('Firestore emulator already connected or connection failed:', e);
    }
  }

  if (!storageConnected) {
    try {
      connectStorageEmulator(storage, 'localhost', 9199);
    } catch (e) {
      console.warn('Storage emulator already connected or connection failed:', e);
    }
  }

  const functionsConnected = (functions as any)._delegate?._url?.includes('localhost');
  if (!functionsConnected) {
    try {
      connectFunctionsEmulator(functions, 'localhost', 5001);
    } catch (e) {
      console.warn('Functions emulator already connected or connection failed:', e);
    }
  }
}

// Initialize Analytics (only in browser, not in Node.js/SSR)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Firebase Analytics initialization failed:', error);
  }
}
export { analytics };

export default app;

